module.exports = __webpack_public_path__ + "img/image-heart.84899497.svg";